import { getChipColor } from "modules/games/utils";
import { FC } from "react";
import Chip from "shared/components/Chip";

type StatusChipProps = {
  status: boolean;
  isLoading?: boolean;
};

const StatusChip: FC<StatusChipProps> = ({ status, isLoading }) => {
  const title = Boolean(status) ? "Active" : "Inactive";

  const color = getChipColor(Boolean(status));

  return <Chip title={title} bgColor={color} isLoading={isLoading} />;
};

export default StatusChip;
